import { roundCloseButton, leftButton, rightButton } from '@project/theme-buttons'

export const gallery2Theme = {
  closeButton: roundCloseButton,
  rightButton,
  leftButton,
  highlightClasses: 'rvit-gallery2-thumbnail-highlight',
  suspendScrolling: true
}